/* src/app/app.component.scss */
:host {
  margin: 0px;
  padding: 0px;
  display: flex;
  flex-direction: column;
}
/*# sourceMappingURL=app.component.css.map */
